<template lang="html">
  <div>
    <server-form
      v-slot="slotProps"
      ref="serverForm"
      :form-action="formAction"
      :form="form"
      :display-save-btn="false">
      <My360Select
        :form="form"
        :options="surveys"
        :label="__('choose-survey')"
        :label-formatter="labelFormatter"
        value-key="id"
        label-key="name"
        prop="survey_id"/>
    </server-form>
  </div>
</template>
<script>
import formAction from '../mixins/formAction'

export default {
  name: 'CurrentSurveySelect',

  mixins: [formAction],

  props: {
    surveys: {
      type: [Array, Object],
      required: true
    },
    currentId: {
      type: String,
      required: false,
      default: () => { return null }
    }
  },

  data () {
    return {
      form: {
        survey_id: this.currentId
      }
    }
  },

  watch: {
    'form.survey_id': function (value) {
      this.$refs.serverForm.submit()
    }
  },

  mounted () {
    // this.form.survey_id = this.currentId
  },

  methods: {
    labelFormatter (option, key) {
      return this.__('label_survey') + ' ' + (key + 1)
    }
  }
}
</script>
